// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"19ceb657","276":"091d9913","480":"9b286f74","688":"25370e9d"}[chunkId] + ".chunk.js";
};